export default function take(array, count) {
    return array.slice(0, count);
}
